// Display obfuscation for surfaces the text-node observer can't reach: the
// address bar (an <input> value, not a text node) and the tab titles (re-rendered
// explicitly so they don't rely on the async observer). Both use the stable
// variant so they don't shimmer on every paint - still freshly randomized per
// page load. Real URL stays in addrInput.dataset.real, revealed on focus.
import { get } from "../shared/settings-store.js";
import { homoglyphStable } from "../shared/obfuscate.js";

export function maxObf() { return get("obfuscation") === "max"; }
export function dispAddr(url) { return maxObf() ? homoglyphStable(url) : url || ""; }
export function dispTitle(t) { return maxObf() ? homoglyphStable(t) : t || ""; }
